import React from "react";
import { StarsReviews } from "./StarsReviews";

interface DesktopCodeContainerProps {
  qrCodeUrl: string;
  appStoreUrl: string;
  playStoreUrl: string;
  appleDesktop: string;
  googleDesktop: string;
  isNonOfferModal?: boolean;
  stars?: number;
  reviewsCount?: string;
}

export const DesktopCodeContainer: React.FC<DesktopCodeContainerProps> = ({
  qrCodeUrl,
  appStoreUrl,
  playStoreUrl,
  appleDesktop,
  googleDesktop,
  isNonOfferModal,
  stars,
  reviewsCount,
}) => {
  return (
    <div className="code-container">
      <img className="qrcode" src={qrCodeUrl} alt="qr-code" />
      <div className="download-app-btns">
        <a
          className="download-button apple-button"
          href={appStoreUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={appleDesktop} alt="app store" />
        </a>
        <a
          className="download-button google-button"
          href={playStoreUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={googleDesktop} alt="play store" />
        </a>
        {isNonOfferModal && (
          <StarsReviews stars={stars ?? 0} reviewsCount={reviewsCount} />
        )}
      </div>
    </div>
  );
};

export default DesktopCodeContainer;
